<div class="confirm-dialog" [class]="'confirm-dialog--' + variant">
  <div class="confirm-dialog-body">
    <div class="confirm-dialog-icon-badge">
      <mat-icon>{{ icon }}</mat-icon>
    </div>

    <h2 mat-dialog-title class="confirm-dialog-title">{{ data.title }}</h2>

    <mat-dialog-content class="confirm-dialog-message-wrap">
      <p class="confirm-dialog-message">{{ data.message }}</p>
      @if (data.question) {
        <p class="confirm-dialog-question">{{ data.question }}</p>
      }
    </mat-dialog-content>
  </div>

  <mat-dialog-actions class="confirm-dialog-footer">
    <button mat-stroked-button type="button" class="confirm-dialog-btn confirm-dialog-btn-cancel" (click)="onCancel()">
      {{ data.cancelLabel || ('button.cancel' | translate) }}
    </button>
    <button mat-raised-button type="button" class="confirm-dialog-btn confirm-dialog-btn-confirm" [color]="confirmColor" (click)="onConfirm()">
      {{ data.confirmLabel || ('button.confirm' | translate) }}
    </button>
  </mat-dialog-actions>
</div>
